import PurchaseTypesEnum from '@/common/enums/purchase-types.enum';

const PURCHASE_TYPES_BY_PRIORITY = Object.freeze([
  PurchaseTypesEnum.TAKEOVER,
  PurchaseTypesEnum.CADENCE,
  PurchaseTypesEnum.GUARANTEED,
  PurchaseTypesEnum.PREFERRED,
  PurchaseTypesEnum.NON_GUARANTEED,
  PurchaseTypesEnum.BONUS_BUY,
  PurchaseTypesEnum.HOUSE_AD,
]);

export default PURCHASE_TYPES_BY_PRIORITY;
